import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api/coupon/`;
const TIER_URL = `${BACKEND_URL}/api/setting/tier-config/`;

// Admin view — include inactive templates so they can be re-activated/edited.
const getCoupons = async () => {
    return await axios.get(`${API_URL}?includeInactive=true`);
};

const createCoupon = async (couponData) => {
    return await axios.post(API_URL, couponData);
};

const editCoupon = async (couponId, updatedData) => {
    return await axios.put(API_URL + couponId, updatedData);
};

// Soft-delete (deactivate).
const deleteCoupon = async (couponId) => {
    return await axios.delete(API_URL + couponId);
};

const grantCoupon = async (payload) => {
    return await axios.post(`${API_URL}grant`, payload);
};

const getCustomerCoupons = async ({ search, status } = {}) => {
    const params = new URLSearchParams();
    if (search) params.append('search', search);
    if (status) params.append('status', status);
    const query = params.toString();
    return await axios.get(`${API_URL}customer-coupons${query ? `?${query}` : ''}`);
};

const getGrantHistory = async () => {
    return await axios.get(`${API_URL}grant-history`);
};

// Reused for the "give for free" tier target dropdown.
const getTiers = async () => {
    return await axios.get(TIER_URL);
};

export default {
    getCoupons,
    createCoupon,
    editCoupon,
    deleteCoupon,
    grantCoupon,
    getCustomerCoupons,
    getGrantHistory,
    getTiers
};
